export default "__VITE_ASSET__CuaMk4W0__"